import React from 'react';
import styles from '../IntradaySignalTestPage.module.css';
import { IntradaySignalTrend, IntradaySignalUpdate } from '../../types/trading';
import { MaFormState } from './signalConfig';
import { FrequencyControls } from './FrequencyControls';

const formatNumber = (value: number | null | undefined): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '--';
  return value.toFixed(6);
};

const formatArray = (values: number[]): string => {
  if (!values.length) return '[]';
  return `[${values.map((v) => v.toFixed(4)).join(', ')}]`;
};

interface MaControlsProps {
  form: MaFormState;
  onChange: (form: MaFormState) => void;
}

export const MaControls: React.FC<MaControlsProps> = ({ form, onChange }) => (
  <>
    <label className={styles.control}>
      <span>Short Window</span>
      <input
        value={form.shortWindowRaw}
        onChange={(e) => onChange({ ...form, shortWindowRaw: e.target.value })}
        type="number"
        min={1}
        className={styles.input}
      />
    </label>
    <label className={styles.control}>
      <span>Long Window</span>
      <input
        value={form.longWindowRaw}
        onChange={(e) => onChange({ ...form, longWindowRaw: e.target.value })}
        type="number"
        min={2}
        className={styles.input}
      />
    </label>
    <label className={styles.control}>
      <span>Trend</span>
      <select
        value={form.trend}
        onChange={(e) => onChange({ ...form, trend: e.target.value as IntradaySignalTrend })}
        className={styles.select}
      >
        <option value="upward">Upward</option>
        <option value="downward">Downward</option>
      </select>
    </label>
    <FrequencyControls
      value={form.frequency}
      onChange={(frequency) => onChange({ ...form, frequency })}
      fixedEvery={1}
    />
  </>
);

interface MaResultsProps {
  update: IntradaySignalUpdate | null;
  shortWindow: number;
  longWindow: number;
}

export const MaResults: React.FC<MaResultsProps> = ({ update, shortWindow, longWindow }) => {
  const shortValues = update?.short_values ?? [];
  const longValues = update?.long_values ?? [];
  return (
    <div className={styles.results}>
      <div className={styles.arrayCard}>
        <h2>Short Window Queue ({shortWindow || '--'})</h2>
        <pre data-testid="intraday-short-values">{formatArray(shortValues)}</pre>
        <p>MA Short (curr): {formatNumber(update?.ma_short_curr ?? null)}</p>
      </div>
      <div className={styles.arrayCard}>
        <h2>Long Window Queue ({longWindow || '--'})</h2>
        <pre data-testid="intraday-long-values">{formatArray(longValues)}</pre>
        <p>MA Long (curr): {formatNumber(update?.ma_long_curr ?? null)}</p>
      </div>
    </div>
  );
};
